<template>
  <!-- 生成二维码页面 -->
  <div class="wrap" style="overflow: hidden">
    <div class="box" style="position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);">

      <VueQr draggable="false" :correctLevel="3" :dotScale="1" :margin="15" :size="256" :text="qrCode" />
      <!-- <el-link style="text-align:center;width:100%;" type="danger">已预约成功，轻触返回</el-link> -->
    </div>
  </div>
</template>

<script>
import VueQr from 'vue-qr'
export default {
    data(){
        return {
            qrCode:'12345678',
        }
    },
    components:{
        VueQr
    },
    props: ['orderQrCode'],
    created(){
       
        this.getInfo(this.$route.query.id);
    },
    methods:{
        getInfo(id){
            this.orderApplyId = id;
        },
    },
    mounted(){
     this.qrCode = this.orderQrCode
    }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/supplier-qr.vue